import {keys} from 'ts-transformer-keys';

import {
    Images,
    Messages,
    Styles
} from '~/shared/src/utilities/dataExtraction';
import {Query} from '~/shared/src/utilities/query';
import {Condition} from '~/shared/src/utilities/condition';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type GraphType = 'force' | 'tree' | 'tangledTree' | 'radialTree';
export type Layout = 'auto' | 'default' | 'cise' | 'euler';
export type Type = 'data' | 'meta';

export type SvgGraphTransform = {
    x : number;
    y : number;
    k : number;
};

export type SvgNodesTransform = {
    [ nodeId : string ] : SvgGraphTransform;
};


// CFG:Graph
export type Graph = {
    data : {
        id : number;
        key : string;
        name : string;

        loadRequestCommand : string;
        loadRequestModule : string;
        loadRequestParams? : {
            [ key : string ] : string;
        };

        graphType : GraphType;
        layout : Layout;
        type : Type;

        colorItemTypes : boolean;
        iconNodeOnly : boolean;
        showLinkCardinality : boolean;
        showLinkNames : boolean;
        showTooltips : boolean;

        svgGraphTransform? : SvgGraphTransform;
        svgNodesTransform? : SvgNodesTransform;
    };
    condition? : Condition;
    images? : Images;
    messages? : Messages;
    permissions? : GroupPermissions;
    query? : Query;
    styles? : Styles;
};
export const graphDataProps = keys<Graph['data']>();
export const graphProps = keys<Graph>();
export const requiredGraphProps = keys<RequiredOf<Graph>>();
